// src/data/lessons.js

const lessons = [
  {
    id: 1,
    title: "Introduction to German",
    description: "Learn the basics of German: greetings, numbers, and simple phrases.",
    duration: "30 min",
    level: "Beginner",
    available: true,
  },
  {
    id: 2,
    title: "German Alphabet & Pronunciation",
    description: "Master the German alphabet and how to pronounce words correctly.",
    duration: "45 min",
    level: "Beginner",
    available: true,
  },
  {
    id: 3,
    title: "Simple Sentences",
    description: "Form simple sentences using basic grammar and vocabulary.",
    duration: "40 min",
    level: "Beginner",
    available: true,
  },
  {
    id: 4,
    title: "Intermediate Grammar",
    description: "Learn past and future tenses and expand your sentence structure.",
    duration: "50 min",
    level: "Intermediate",
    available: true,
  },
  {
    id: 5,
    title: "Everyday Conversations",
    description: "Practice dialogues for everyday situations like shopping and traveling.",
    duration: "55 min",
    level: "Intermediate",
    available: true,
  },
  {
    id: 6,
    title: "Advanced Grammar & Subjunctive",
    description: "Explore complex grammar topics, including subjunctive mood and idioms.",
    duration: "60 min",
    level: "Advanced",
    available: false,
  },
  {
    id: 7,
    title: "Business German",
    description: "Learn German used in professional and business contexts.",
    duration: "70 min",
    level: "Advanced",
    available: false,
  },
];

export default lessons;
